import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import(
      './viewer/SlideShowContainer' /* webpackChunkName: "SlideShowContainer" */
    ),
    import(
      './viewer/SlideShowContainer.controller' /* webpackChunkName: "SlideShowContainer" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('SlideShowContainer', UiTypes),
};

export default entry;
